import { Tooltip } from '@mui/material';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import React from 'react';

const getLineClampSx = lines => ({
  whiteSpace: 'break-spaces',
  display: lines > 1 ? '-webkit-box' : 'inline',
  lineClamp: lines,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

const LineClampTooltip = ({ children, lines = 2, title = null, ...rest }) => {
  return (
    <Tooltip title={title || children} {...rest}>
      <Box component="span" sx={getLineClampSx(lines)}>
        {children}
      </Box>
    </Tooltip>
  );
};

LineClampTooltip.propTypes = {
  children: PropTypes.node.isRequired,
  lines: PropTypes.number,
  title: PropTypes.string,
};

export default LineClampTooltip;
